import { useEffect } from "react";

// Each card is 1200x630 (Facebook/Twitter/LinkedIn standard)
// Pinterest will adapt; Open Graph standard.
const CARDS = [
  {
    id: "the-tap-in",
    eyebrow: "FREE 9-MIN AUDIO ESSAY",
    title: "The HYGIENE That Reclaimed My Life.",
    sub: "Tap-In. Ground. Say Hello. Say Thank You.",
    cta: "Listen + Free Calendar",
  },
  {
    id: "toxic-positivity",
    eyebrow: "AUDIO ESSAY · MIND HYGIENE",
    title: "The Quiet Violence of Toxic Positivity.",
    sub: "10 phrases that erase you · what to say instead.",
    cta: "Listen Free",
  },
  {
    id: "messy-middle-code-of-conduct",
    eyebrow: "AUDIO ESSAY · 12 MIN",
    title: "The Messy Middle & Your Code of Conduct.",
    sub: "Build your armor before life gets heavy.",
    cta: "Listen Free",
  },
  {
    id: "tap-in-calendar",
    eyebrow: "FREE PRINTABLE · 13 PAGES",
    title: "The 12-Month I GET TO Calendar.",
    sub: "365 daily reframes · weekly walk-with-me emails.",
    cta: "Send Me the Calendar",
    highlightTitle: "I GET TO",
  },
];

const Card = ({ card }) => (
  <div
    id={`card-${card.id}`}
    data-testid={`card-${card.id}`}
    className="relative overflow-hidden flex flex-col justify-between"
    style={{
      width: 1200,
      height: 630,
      background: "linear-gradient(135deg, #042F2E 0%, #25a1c2 50%, #068fa2 100%)",
      padding: "60px 80px",
      color: "white",
      fontFamily: "Georgia, serif",
    }}
  >
    {/* Decorative blurs */}
    <div style={{ position: "absolute", top: -100, right: -100, width: 400, height: 400, background: "rgba(94, 234, 212, 0.18)", borderRadius: "50%", filter: "blur(80px)" }} />
    <div style={{ position: "absolute", bottom: -150, left: -100, width: 500, height: 500, background: "rgba(204, 251, 241, 0.12)", borderRadius: "50%", filter: "blur(100px)" }} />

    {/* TOP — Brand */}
    <div style={{ position: "relative", zIndex: 2 }}>
      <p style={{
        fontFamily: "system-ui, sans-serif",
        fontSize: 16,
        letterSpacing: 4,
        textTransform: "uppercase",
        fontWeight: 700,
        color: "#5EEAD4",
        marginBottom: 8,
      }}>
        Mind Body Spirit HYGIENE™
      </p>
      <p style={{ fontStyle: "italic", color: "#CCFBF1", fontSize: 22 }}>
        A whole new way of living.
      </p>
    </div>

    {/* MIDDLE — Title */}
    <div style={{ position: "relative", zIndex: 2 }}>
      <p style={{
        fontFamily: "system-ui, sans-serif",
        fontSize: 14,
        letterSpacing: 4,
        textTransform: "uppercase",
        fontWeight: 700,
        color: "#5EEAD4",
        marginBottom: 14,
      }}>
        {card.eyebrow}
      </p>
      <h1 style={{
        fontSize: 76,
        lineHeight: 1.05,
        margin: 0,
        marginBottom: 20,
        letterSpacing: -1,
        fontWeight: 400,
      }}>
        {card.highlightTitle ? (
          <>
            The 12-Month <em style={{ color: "#5EEAD4", fontStyle: "italic" }}>I GET TO</em><br />Calendar.
          </>
        ) : card.title}
      </h1>
      <div style={{ width: 80, height: 3, background: "#5EEAD4", marginBottom: 20 }} />
      <p style={{ fontStyle: "italic", color: "#CCFBF1", fontSize: 30, margin: 0 }}>
        {card.sub}
      </p>
    </div>

    {/* BOTTOM — CTA + URL */}
    <div style={{ position: "relative", zIndex: 2, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
      <div style={{
        display: "inline-block",
        background: "#5EEAD4",
        color: "#042F2E",
        fontFamily: "system-ui, sans-serif",
        fontWeight: 700,
        fontSize: 18,
        letterSpacing: 2,
        textTransform: "uppercase",
        padding: "14px 28px",
        borderRadius: 999,
      }}>
        {card.cta}
      </div>
      <p style={{
        fontFamily: "system-ui, sans-serif",
        fontSize: 18,
        color: "rgba(255,255,255,0.7)",
      }}>
        mindbodyspirithygienetools.com
      </p>
    </div>
  </div>
);

export default function ShareCardsPreview() {
  useEffect(() => {
    document.title = "Share Cards · Render | Temple Franklin";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  return (
    <div style={{ background: "#efeae7", minHeight: "100vh", padding: 40 }} data-testid="share-cards-page">
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <h1 style={{ fontFamily: "Georgia, serif", fontSize: 36, color: "#042F2E", marginBottom: 8 }}>
          Open Graph Share Cards (1200×630)
        </h1>
        <p style={{ color: "#475569", marginBottom: 30 }}>
          Each card below renders at the exact OG size. Used for og:image meta tags.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
          {CARDS.map((c) => (
            <div key={c.id} style={{ background: "white", padding: 20, borderRadius: 16, border: "1px solid #CCFBF1" }}>
              <p style={{ fontFamily: "system-ui, sans-serif", fontSize: 12, color: "#25a1c2", fontWeight: 700, marginBottom: 12 }}>
                /og/{c.id}.png
              </p>
              <Card card={c} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
